import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { IAttachmentList } from './types';
import { AttachmentItem } from './AttachmentItem';

const useStyles = makeStyles(() => ({
    root: {
        maxHeight: 200,
        overflow: 'scroll',
        paddingLeft: 15,
        paddingRight: 15,
    },
}));

export const AttachmentList = ({
    attachments,
    files,
    setFiles,
    ...props
}: IAttachmentList) => {
    const classes = useStyles();

    return (
        <Box py={1} px={2} className={classes.root} {...props}>
            {attachments.map((item: File, key: number) => (
                <AttachmentItem
                    key={key}
                    attachment={item}
                    files={files}
                    setFiles={setFiles}
                />
            ))}
        </Box>
    );
};
